// Comprehensive polyfills for Node.js globals needed by amazon-cognito-identity-js
// This file should be imported at the top of your main.jsx

// Import proper polyfills
import { Buffer } from 'buffer';

// Define global if it doesn't exist
if (typeof global === 'undefined') {
  window.global = window;
}

// Use the proper Buffer polyfill
window.Buffer = Buffer;

// Define process if it doesn't exist
if (typeof process === 'undefined') {
  window.process = {
    env: {},
    browser: true,
    version: '',
    versions: {},
    platform: 'browser',
    nextTick: (callback) => Promise.resolve().then(callback)
  };
}

// Ensure crypto is available
if (typeof crypto === 'undefined') {
  console.warn('Crypto API not available. Some features may not work properly.');
}

// Define TextEncoder and TextDecoder if they don't exist
if (typeof TextEncoder === 'undefined') {
  window.TextEncoder = class TextEncoder {
    encode(string) {
      const utf8 = unescape(encodeURIComponent(string));
      const arr = new Uint8Array(utf8.length);
      for (let i = 0; i < utf8.length; i++) {
        arr[i] = utf8.charCodeAt(i);
      }
      return arr;
    }
  };
}

if (typeof TextDecoder === 'undefined') {
  window.TextDecoder = class TextDecoder {
    constructor(encoding = 'utf-8') {
      this.encoding = encoding;
    }
    decode(buffer) {
      if (buffer instanceof Uint8Array) {
        return decodeURIComponent(escape(String.fromCharCode.apply(null, buffer)));
      }
      return '';
    }
  };
}

// Define setImmediate if it doesn't exist
if (typeof setImmediate === 'undefined') {
  window.setImmediate = (callback, ...args) => setTimeout(callback, 0, ...args);
}

// Define clearImmediate if it doesn't exist
if (typeof clearImmediate === 'undefined') {
  window.clearImmediate = (id) => clearTimeout(id);
}

// Define URLSearchParams if it doesn't exist (for older browsers)
if (typeof URLSearchParams === 'undefined') {
  console.warn('URLSearchParams not available. Some features may not work properly.');
}

// Define fetch if it doesn't exist (for older browsers)
if (typeof fetch === 'undefined') {
  console.warn('Fetch API not available. Some features may not work properly.');
}

// Ensure console methods exist
if (typeof console === 'undefined') {
  window.console = {
    log: () => {},
    warn: () => {},
    error: () => {},
    info: () => {},
    debug: () => {}
  };
}

console.log('Polyfills loaded successfully for amazon-cognito-identity-js');
